// extracted by mini-css-extract-plugin
module.exports = {"yearSection":"bookshelf_yearSection___B9Ns","GridContainer":"bookshelf_GridContainer__3e0O7","Writing":"bookshelf_Writing__9bNhi","SubHeading":"bookshelf_SubHeading__xNcDc"};